import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, first, tap, map, switchMap, catchError } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class ResetTokenGuard  {
  protected router = inject(Router);
  private loginService = inject(LoginService);

  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // We need to do an initial wait for kicked off on page load login to complete
    // (the app tries to refresh the login session on startup to see if user currently logged in)
    // Now dispatch the loginWithResetToken, and wait for it to complete

    const token = route.params['token'];

    return this.loginService.completedLoginStatus()
      .pipe(
        switchMap(() => this.loginService.loginWithResetToken(token)),
        catchError(err => {
          console.log(err);
          return of(null);
        }),
        map(loginResponse => {
          if (!loginResponse) {
            this.router.navigateByUrl('/reset-token-invalid');
            return false;
          }

          return true;
        })
      )
  }
  
}
